<div class="min-h-screen bg-section flex flex-col items-center justify-center p-6 relative overflow-hidden text-body-text selection:bg-btn/30">
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12" />
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-40 h-40 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-40 sm:opacity-60 pointer-events-none">
    <img src="amla-bottom-right.png" alt="Ashwagandha Root" class="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12" />
  </div>

  <!-- Main Content -->
  <div class="relative z-10 w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-6 md:space-y-8 animate-fade-in px-4">
    <!-- Logo/Brand -->
    <div class="space-y-4">
      <img src="FINAL.png" alt="Aarvya Logo" class="w-48 sm:w-64 h-auto mx-auto object-contain">
    </div>

    <!-- Auth Card -->
    <div class="w-full max-w-md mx-auto bg-white/80 backdrop-blur-sm border border-[#E5DDD5] shadow-lg p-6 sm:p-8 space-y-5 text-left">
      <div class="space-y-1">
        <h2 class="text-2xl sm:text-3xl font-serif text-heading">Reset Your Password</h2>
        <p class="text-sm text-muted" *ngIf="!isSuccess && !errorMessage && !isVerifyingCode">Enter your new password below to regain access.</p>
      </div>

      <!-- Verifying State -->
      <div *ngIf="isVerifyingCode" class="py-12 flex flex-col items-center gap-4 text-center">
        <div class="w-8 h-8 border-2 border-btn border-t-transparent rounded-full animate-spin"></div>
        <p class="text-sm text-muted font-serif italic">Verifying your reset link...</p>
      </div>

      <!-- Success State -->
      <div *ngIf="isSuccess" class="py-8 space-y-4 text-center">
        <div class="w-16 h-16 bg-green-50 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <h3 class="text-xl font-serif text-heading">Password Reset Successfully</h3>
        <p class="text-sm text-muted">Your password has been updated. Redirecting you to sign in...</p>
        <button routerLink="/sign-in" class="text-sm text-btn hover:text-body-text font-serif underline underline-offset-4">Click here if not redirected</button>
      </div>

      <!-- Error State -->
      <div *ngIf="errorMessage && !isSuccess" class="py-8 space-y-4 text-center animate-fade-in">
        <div class="w-16 h-16 bg-red-50 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
          </svg>
        </div>
        <p class="text-sm text-red-700 font-serif px-4">{{ errorMessage }}</p>
        <div class="pt-4">
            <a routerLink="/forgot-password" class="w-full px-6 py-2 border border-[#E5DDD5] text-body-text font-serif text-sm rounded-sm hover:bg-section transition-all inline-block">Request New Link</a>
        </div>
      </div>

      <!-- Form -->
      <form [formGroup]="resetForm" (ngSubmit)="submit()" class="space-y-4" *ngIf="isValidCode && !isSuccess && !isVerifyingCode">
        <div class="space-y-1">
          <label class="block text-xs font-serif text-heading tracking-wide">New Password</label>
          <div class="relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Min. 6 characters"
              class="w-full px-4 py-3 bg-white border text-body-text placeholder-muted/60 font-serif focus:outline-none transition-colors rounded-sm pr-10"
              [class.border-[#E5DDD5]]="!password?.touched || password?.valid"
              [class.border-red-300]="password?.invalid && password?.touched"
              [disabled]="isSubmitting"
            />
            <button
              type="button"
              (click)="showPassword = !showPassword"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-heading focus:outline-none"
            >
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
          <div *ngIf="password?.invalid && password?.touched" class="mt-1 text-xs text-red-500 font-sans">
            <span *ngIf="password?.hasError('required')">Password is required</span>
            <span *ngIf="password?.hasError('minlength')">Minimum 6 characters required</span>
          </div>
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-serif text-heading tracking-wide">Confirm Password</label>
          <div class="relative">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              placeholder="Repeat your password"
              class="w-full px-4 py-3 bg-white border text-body-text placeholder-muted/60 font-serif focus:outline-none transition-colors rounded-sm pr-10"
              [class.border-[#E5DDD5]]="!confirmPassword?.touched || confirmPassword?.valid"
              [class.border-red-300]="(confirmPassword?.touched && resetForm.errors?.['passwordsMismatch'])"
              [disabled]="isSubmitting"
            />
            <button
              type="button"
              (click)="showConfirmPassword = !showConfirmPassword"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-heading focus:outline-none"
            >
              <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
          <div *ngIf="(confirmPassword?.touched && resetForm.errors?.['passwordsMismatch'])" class="mt-1 text-xs text-red-500 font-sans">
            Passwords do not match
          </div>
        </div>

        <button
          type="submit"
          class="w-full px-6 py-3 bg-btn text-white font-serif tracking-wide rounded-sm hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm sm:text-base flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
          [disabled]="resetForm.invalid || isSubmitting"
        >
          <span *ngIf="!isSubmitting">Reset Password</span>
          <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
        </button>
      </form>

      <div class="pt-2 text-xs sm:text-sm text-muted flex items-center justify-center gap-1" *ngIf="!isSuccess && !isVerifyingCode">
        <span>Back to</span>
        <a routerLink="/sign-in" class="text-heading underline underline-offset-2 hover:text-body-text">Sign in</a>
      </div>
    </div>
  </div>
</div>
